import React from 'react';
import { Col } from 'react-bootstrap';
import { Skeleton } from '../common/skeleton/Skeleton';

const MemberSkeleton = () => {
  return (
    <>
      <Col>
        <div>
          <Col>
            <Skeleton count={8} height={35} marginBottom={15} />
          </Col>
        </div>
      </Col>
    </>
  );
};

export default MemberSkeleton;
